import { Dialog, Typography } from "flux";
import { BaseDialogProps } from "../../contexts/dialog-context";

interface ConfirmationDialogProps extends BaseDialogProps {
  title: string;
  description: string;
  primaryButtonText: string;
  danger?: true;
  showCancel?: boolean;
  compactHeader?: boolean;
  wideButtons?: boolean;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  onClose,
  title,
  description,
  primaryButtonText,
  danger = false,
  showCancel,
  compactHeader,
  wideButtons
}) => {
  return (
    <Dialog
      size="xs"
      title={title}
      open={open}
      onClose={onClose}
      primaryButtonText={primaryButtonText}
      danger={danger}
      showCancel={showCancel}
      compactHeader={compactHeader}
      wideButtons={wideButtons}
      dataDogIdentifier="confirm dialog submit"
      // Radix modal dialogs set pointer-events: none on <body>, which this MUI
      // dialog inherits through its portal — leaving it visible but unclickable
      // when stacked above one (e.g. the Edit Image dialog). Explicitly restore
      // pointer events; this is a no-op when no Radix modal is open.
      sx={{ pointerEvents: "auto" }}
    >
      <Typography variant="h6">{description}</Typography>
    </Dialog>
  );
};

export default ConfirmationDialog;
